import httpHelper from "@/helpers/httpHelper";
// action types 
export const GET_UNDONE_REFUND_DETAILS = "getUndoneRefundDetails";
export const PAY_REFUND = "payRefund";
// mutation types
export const SET_UNDONE_REFUND_DETAILS = "setUndoneRefundDetails";


export default {
    state: {
        detailsUndoneRefund: {},
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedDetailsUndoneRefund(state) {
            return state.detailsUndoneRefund;
        },
    },
    actions: {
        /**
         * Set the payRefund Status 
         * @param state
         * @param payload
         */
        [PAY_REFUND](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .postData(`${payload.api}/${payload.id}`, { "tracking_number": payload.tracking_number, "bank_account_id": payload.bank_account_id })
                    .then((response) => {

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
        /**
         * Set the getUndoneRefundDetails Status 
         * @param state
         * @param payload
         */
        [GET_UNDONE_REFUND_DETAILS](context, payload) {

            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(`${payload.api}/${payload.id}`)
                    .then((response) => {
                        if (response.result.child_document != null) {
                            Object.assign(response.result, { status: 'انجام شده' })
                        } else {
                            Object.assign(response.result, { status: 'انجام نشده' })
                        }
                        context.commit(SET_UNDONE_REFUND_DETAILS, response.result);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
    },
    mutations: {

        [SET_UNDONE_REFUND_DETAILS](state, payload) {
            state.detailsUndoneRefund = payload;
        },

    }
};